/* FormulaBlack theme JS */
(function () {
  // Scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // Product form (main-product section)
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var radios = form.querySelectorAll('input[name="id"]');
    var qtyInput = form.querySelector('[data-qty]');
    var priceEl = form.querySelector('[data-atc-price]');
    var atcBtn = form.querySelector('[data-atc]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function update() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) return;
      var price = parseInt(checked.dataset.price, 10);
      var available = checked.dataset.available === 'true';
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = qty;
      if (priceEl) priceEl.textContent = money(price * qty);
      if (atcBtn) {
        atcBtn.disabled = !available;
        var label = atcBtn.querySelector('[data-atc-label]');
        if (label) label.textContent = available ? label.dataset.add : label.dataset.soldout;
      }
      form.querySelectorAll('.opt').forEach(function (o) {
        o.classList.toggle('selected', o.contains(checked));
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    form.querySelectorAll('[data-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        qtyInput.value = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qtyBtn, 10)));
        update();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', update);
    update();
  }

  // Product gallery thumbs
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg && t.dataset.src) {
        mainImg.src = t.dataset.src;
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      }
    });
  });

  // Cart quantity auto-submit
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var f = input.closest('form');
      if (f) f.submit();
    });
  });
})();
